import styled from "styled-components"
import { Title } from "../../../../../../../../../_webui/layout/components/Typography/Title"

const StyledTitle = styled(Title)`
  white-space: pre-wrap;
`

export const Styled = { StyledTitle }
